import { PartialStoryFn, StoryContext } from '@storybook/addons';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Checkbox } from '../checkbox';

const meta = {
  argTypes: {
    alignment: { table: { disable: true } },
    checked: { table: { disable: true } },
    disabled: { table: { disable: true } },
    error: { table: { disable: true } },
    id: { table: { disable: true } },
    indeterminate: { table: { disable: true } },
    label: { table: { disable: true } },
    name: { table: { disable: true } },
    required: { table: { disable: true } },
    requiredMessage: { table: { disable: true } },
    tooltip: { table: { disable: true } },
    value: { table: { disable: true } },
  },
  args: {
    alignment: '',
    checked: false,
    disabled: false,
    error: false,
    id: '',
    indeterminate: false,
    label: 'Checkbox label',
    name: 'checkbox-name',
    required: false,
    requiredMessage: '',
    tooltip: '',
    value: '',
  },
  decorators: [
    (story: PartialStoryFn, { args: { tooltip } }: StoryContext) =>
      html`
        <style type="text/css">
          #root,
          .docs-story {
            padding-top: ${tooltip ? '2rem' : ''};
          }
        </style>
        ${story()}
      `,
  ],
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Checkbox/',
};

interface Story {
  alignment: Checkbox['alignment'];
  checked: Checkbox['checked'];
  disabled: Checkbox['disabled'];
  error: Checkbox['error'];
  id: string;
  indeterminate: Checkbox['indeterminate'];
  label: string;
  name: Checkbox['name'];
  required: Checkbox['required'];
  requiredMessage: Checkbox['requiredMessage'];
  tooltip: Checkbox['tooltip'];
  value: Checkbox['value'];
}

const story = ({
  alignment,
  checked,
  disabled,
  error,
  id,
  indeterminate,
  label,
  name,
  required,
  requiredMessage,
  tooltip,
  value,
}: Partial<Story>) => html`
  <abds-checkbox
    alignment="${ifDefined(alignment || undefined)}"
    checked="${ifDefined(checked || undefined)}"
    disabled="${ifDefined(disabled || undefined)}"
    error="${ifDefined(error || undefined)}"
    id="${ifDefined(id || undefined)}"
    indeterminate="${ifDefined(indeterminate || undefined)}"
    name="${ifDefined(name || undefined)}"
    required="${ifDefined(required || undefined)}"
    required-message="${ifDefined(requiredMessage || undefined)}"
    tooltip="${ifDefined(tooltip || undefined)}"
    value="${ifDefined(value || undefined)}"
  >
    ${label}
  </abds-checkbox>
`;

export { meta, story };
